var React = require('react');

function HomeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.5446 32.8922H15.378V22.6144H24.8224V32.8922H30.6558V17.0588L20.1002 9.14213L9.5446 17.0588V32.8922ZM6.76685 35.6699V15.6699L20.1002 5.66992L33.4335 15.6699V35.6699H22.0446V25.3921H18.1557V35.6699H6.76685Z","fill":"#0066FF"}));
}

HomeInline.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = HomeInline;

HomeInline.default = HomeInline;
